import * as v from 'valibot';
import type { FieldDefinition } from '@v2/components/SchemaForm/types';

export const partnerSchema = v.object({
  name: v.pipe(v.string(), v.minLength(1, 'Partner name is required')),
});

export type PartnerFormValues = v.InferOutput<typeof partnerSchema>;

export const partnerFields: FieldDefinition[] = [
  { name: 'name', label: 'Partner Name', type: 'text', placeholder: 'Enter partner name' },
];
